/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Methodologies supported for resampling numeric fields
 */
export enum AggregationTypeEnum {
    END_OF_PERIOD = 'END_OF_PERIOD',
    SUM = 'SUM',
    AVERAGE = 'AVERAGE',
}
